/**
 * A45: «Сохранить» = локальный черновик отчёта (localStorage, ключ на
 * бронь+оператора). Отправленный отчёт правится только после возврата из OO,
 * поэтому до отправки данные живут здесь и восстанавливаются при открытии.
 */
import type { ServiceLine, DiscountLine, PayState } from "./reportModel";
import type { RPlayer } from "./reportPlayers";

export interface ReportDraft {
  players: number; questPrice: number; teaPrice: number; mcPrice?: number; nightSurcharge?: number;
  services: ServiceLine[]; discounts: DiscountLine[]; pay: PayState;
  change: number; changeSrcId: string | null; emp: { id: string; name: string } | null;
  teaActive: boolean; teaRoomId: string | null; cleaners: { id: string; name: string }[];
  taxi: number; mkStatus: string; achSel: string[]; activity: string; comment: string; full: boolean; rPlayers?: RPlayer[];
}

const key = (b: number, o: string) => `ub_rdraft_${b}_${o}`;

export function loadDraft(b: number, o: string): ReportDraft | null {
  try { const raw = localStorage.getItem(key(b, o)); return raw ? (JSON.parse(raw) as ReportDraft) : null; } catch { return null; }
}

export function saveDraft(b: number, o: string, d: ReportDraft): boolean {
  try { localStorage.setItem(key(b, o), JSON.stringify(d)); return true; } catch { return false; }
}

export function clearDraft(b: number, o: string): void {
  try { localStorage.removeItem(key(b, o)); } catch { /* квота/private mode — не критично */ }
}

/* МК-исход из КАРТОЧКИ игры до сдачи отчёта (26.08, владелец): полного драфта
 * может не быть — отдельный ключ; форма читает его как стартовое значение,
 * при полном драфте пишем прямо в него. Очистка вместе с clearDraft формы. */
const mkKey = (b: number, o: string) => `ub_mkdraft_${b}_${o}`;
export function loadMkDraft(b: number, o: string): string {
  try { return localStorage.getItem(mkKey(b, o)) ?? ""; } catch { return ""; }
}
export function saveMkDraft(b: number, o: string, v: string): void {
  try {
    const d = loadDraft(b, o);
    if (d) { d.mkStatus = v; saveDraft(b, o, d); }
    if (v) localStorage.setItem(mkKey(b, o), v); else localStorage.removeItem(mkKey(b, o));
  } catch { /* private mode */ }
}
export function clearMkDraft(b: number, o: string): void {
  try { localStorage.removeItem(mkKey(b, o)); } catch { /* ignore */ }
}
